const home = {
    state: {
        phoneId: '',
        step: 0,
        show_advert:true,
        show_download:true,
        home_advert:{},
        app_download_link: ''
    },
    mutations: {
        setPhoneId(state, i) {
            state.phoneId = i
        },
        setStep(state, s) {
            state.step = s
        },
        showAdvert(state, a) {
		    state.home_advert = a;
        },
        setShowAdvert(state, a){
            state.show_advert = a;
        },
        setShowDownload(state, a){
            state.show_download = a;
        },
        setAppDownloadLink(state, a){
            state.app_download_link = a;
        },

    }
}

export default home
